// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__rXCWs","shake":"FloatingButton_shake__fX3Jm"};